import { Option } from './pageConfig/Types';

export const EMPTY_OPTION: Option = {
  label: '',
  value: '',
};
